const __WEBPACK_NAMESPACE_OBJECT__ = require("@statsig/statsig-node-core");